import { render, staticRenderFns } from "./UserResume.vue?vue&type=template&id=66a1cac7&scoped=true&"
import script from "./UserResume.vue?vue&type=script&lang=js&"
export * from "./UserResume.vue?vue&type=script&lang=js&"
import style0 from "./UserResume.vue?vue&type=style&index=0&id=66a1cac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a1cac7",
  null
  
)

export default component.exports